// @flow
import React, { Component } from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { Input, Menu } from 'semantic-ui-react';
import type { Match, LocationShape } from 'react-router-dom';

type Props = {
    clientId: Guid,
    getData: () => Promise<{ name: string, path: LocationShape }[]>,
    match: Match
};
class SubMenuWithData extends Component<
    Props,
    { data: { name: string, path: LocationShape }[], search: string }
> {
    state = { data: [], search: '' };
    componentDidMount() {
        this.getData();
    }
    componentDidUpdate(prevProps: Props) {
        if (this.props.clientId !== prevProps.clientId) {
            this.getData();
        }
    }
    getData() {
        this.props.getData().then(data => this.setState({ data: data, search: '' }));
    }
    render() {
        return (
            <Menu.Menu
                style={{
                    transition: 'max-height 5s ease-out',
                    maxHeight: this.state.data.length ? '100em' : 0,
                    overflow: 'hidden'
                }}
            >
                {this.state.data.length > 5 && (
                    <Menu.Item>
                        <Input
                            icon="search"
                            onChange={(e, data) =>
                                this.setState({ search: data.value.toLowerCase() })}
                            placeholder="Search..."
                            value={this.state.search}
                        />
                    </Menu.Item>
                )}
                {this.state.data
                    .filter(el => el.name.toLowerCase().indexOf(this.state.search) !== -1)
                    .slice(0, 5)
                    .map(el => (
                        <Menu.Item
                            as={NavLink}
                            content={el.name}
                            key={el.path.pathname}
                            to={el.path}
                        />
                    ))}
            </Menu.Menu>
        );
    }
}

export default SubMenuWithData;



// WEBPACK FOOTER //
// ./components/molecules/SubMenuWithData.jsx